import { type TeamTargetResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import { useAuth } from '@on3/ui-lib/index';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { profileAdmin } from '@on3/ui-lib/utils/auth/constants';
import { PlayerInterestsHeader } from 'components/Db/Profile/PlayerInterests/PlayerInterestsHeader';
import { PlayerInterestsItem } from 'components/Db/Profile/PlayerInterests/PlayerInterestsItem';
import { MockDataBar } from 'components/Mock/MockDataBar';
import useAthlete from 'contexts/AthleteProvider';
import { AthleteType } from 'utils/player';

import styles from './TopInterestsMock.module.scss';

interface ITopInterestsMockProps {
  interests?: TeamTargetResponse[] | [];
}

export const TopInterestsMock = ({ interests }: ITopInterestsMockProps) => {
  const { athlete, hasBaseProfile } = useAthlete();
  const { user } = useAuth();
  const canEdit = userHasPermission(profileAdmin, user) && hasBaseProfile;
  const listLength = interests?.length || 0;

  const playerType = AthleteType.Base;
  const mockCount = Math.max(0, 5 - listLength);
  const positionAbbreviation = interests?.[0]?.positionAbbreviation ?? 'pos';

  return (
    <div className={styles.block}>
      <div role="table">
        {listLength > 0 && (
          <PlayerInterestsHeader
            playerType={AthleteType.Base}
            positionAbbreviation={positionAbbreviation}
          />
        )}
        <ol>
          {interests?.map((team, index) => (
            <PlayerInterestsItem
              key={`interest-${index}`}
              playerType={playerType}
              {...team}
            />
          ))}
          {Array.from({ length: mockCount }).map((_, rank) => (
            <li className={styles.item} key={rank}>
              <span>{listLength + rank + 1}</span>
              <MockDataBar />
              <MockDataBar />
            </li>
          ))}
        </ol>
      </div>
      <div>
        <Link
          className={styles.edit}
          forceReload
          href={
            canEdit
              ? `/db/${athlete.slug}/elite/network/profile/top-interests/`
              : `/db/${athlete.slug}/claim-profile/`
          }
        >
          <Pen />
          Edit Teams
        </Link>
      </div>
    </div>
  );
};
